import React from "react";

import { Code, Braces, Pencil, Eye } from "lucide-react";

import { Tabs, TabsList, TabsTrigger } from "@/app/admin/_common/ui/tabs";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/admin/_common/ui/tooltip";
import { tabTriggerClassName } from "@/app/admin/shows/[show_id]/_cmp/ShowDetailHeader";
import { setSelectedMainTab, useSelectedMainTab } from "../../documents/editor/EditorContext";

const TABS = [
  { value: "editor", label: "Edit", Icon: Pencil },
  { value: "preview", label: "Preview", Icon: Eye },
  { value: "html", label: "HTML output", Icon: Code },
  { value: "json", label: "JSON output", Icon: Braces },
] as const;

export default function MainTabsGroup() {
  const selectedMainTab = useSelectedMainTab();

  return (
    <Tabs
      value={selectedMainTab ?? "editor"}
      onValueChange={(v) => setSelectedMainTab(v as (typeof TABS)[number]["value"])}
    >
      <TabsList className="h-auto gap-5 bg-transparent p-0">
        {TABS.map(({ value, label, Icon }) => (
          <Tooltip key={value}>
            <TooltipTrigger asChild>
              <TabsTrigger value={value} className={tabTriggerClassName}>
                <Icon className="size-4" />
              </TabsTrigger>
            </TooltipTrigger>
            <TooltipContent>{label}</TooltipContent>
          </Tooltip>
        ))}
      </TabsList>
    </Tabs>
  );
}
